import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const entry: ISVGPersonalProps = {
  viewBox: '0 0 22 22',
  content: (
    <>
      <path
        id="Path_1090"
        data-name="Path 1090"
        d="M15.293,6.394h2.145a1.5,1.5,0,0,1,1.43,1.555v.777M15.293,18.833h2.145a1.5,1.5,0,0,0,1.43-1.555V16.5M7.019,18.39l4.289,1.4a1.34,1.34,0,0,0,1.265-.245,1.6,1.6,0,0,0,.575-1.248V6.931a1.6,1.6,0,0,0-.575-1.248,1.34,1.34,0,0,0-1.265-.245l-4.289,1.4A1.549,1.549,0,0,0,6,8.33V16.9A1.549,1.549,0,0,0,7.019,18.39Zm3.271-5.776h0m8.579,0H15.293m0,0,1.43-1.555m-1.43,1.555,1.43,1.555"
        transform="translate(-1.434 -1.614)"
        fill="none"
        stroke="#707070"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path id="Path_1091" data-name="Path 1091" d="M0,0H22V22H0Z" fill="none" />
    </>
  ),
};
